/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { skillSummarySchema } from './skillSummarySchema';
import { teamRoleSummarySchema } from './teamRoleSummarySchema';

export const openPositionSummarySchema = z.object({
  openPositionId: z.int(),
  openPositionName: z.string(),
  get role() {
    return teamRoleSummarySchema;
  },
  get skills() {
    return z.array(skillSummarySchema);
  },
});
